export const MEASUREMENT_UNITS = [
  { code: "KGS", name: "Kilogramos", description: "Kilogramos" },
  { code: "LTS", name: "Litros", description: "Litros" },
  { code: "UNI", name: "Unidades", description: "Unidades" },
  { code: "MNG", name: "Mangas", description: "Mangas" },
  { code: "CAJA", name: "Cajas", description: "Cajas" },
  { code: "SSGG", name: "SSGG", description: "Servicios Generales" },
] as const;

export type UnitCode = (typeof MEASUREMENT_UNITS)[number]["code"];

export const UNIT_OPTIONS = MEASUREMENT_UNITS.map((unit) => ({
  value: unit.code,
  label: `${unit.code} - ${unit.name}`,
}));

// Production-specific unit types (for production batches)
export const PRODUCTION_UNITS = [
  { code: "CAJA", name: "Cajas", singular: "caja", plural: "cajas" },
  { code: "CAJ", name: "Cajas", singular: "caja", plural: "cajas" },
  { code: "UNI", name: "Unidades", singular: "unidad", plural: "unidades" },
  { code: "KGS", name: "Kilos", singular: "kilo", plural: "kilos" },
  { code: "LTS", name: "Litros", singular: "litro", plural: "litros" },
  { code: "MNG", name: "Mangueras", singular: "manguera", plural: "mangueras" },
] as const;

export type ProductionUnitCode = (typeof PRODUCTION_UNITS)[number]["code"];

export const PRODUCTION_UNIT_OPTIONS = PRODUCTION_UNITS.map((unit) => ({
  value: unit.code,
  label: unit.name,
}));

/**
 * Get the display label for a production unit (singular or plural based on quantity)
 * @param code - The production unit code ('CAJA' or 'UNI')
 * @param quantity - The quantity to determine singular/plural form
 * @returns The appropriate unit label (e.g., "cajas", "unidad")
 */
export function getProductionUnitLabel(
  code: ProductionUnitCode | string | undefined | null,
  quantity: number = 1
): string {
  const unit = PRODUCTION_UNITS.find((u) => u.code === code);
  if (!unit) return quantity === 1 ? "caja" : "cajas"; // Default to cajas
  return quantity === 1 ? unit.singular : unit.plural;
}
